'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var uitkReactUtils = require('uitk-react-utils');
var styles = require('./uitk-button.css');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var styles__default = /*#__PURE__*/_interopDefaultLegacy(styles);

var getClassNameList = uitkReactUtils.classNames.bind(styles__default["default"]);
exports.UitkButtonSize = void 0;
(function (UitkButtonSize) {
    UitkButtonSize["SMALL"] = "small";
    UitkButtonSize["MEDIUM"] = "medium";
    UitkButtonSize["LARGE"] = "large";
})(exports.UitkButtonSize || (exports.UitkButtonSize = {}));
exports.UitkButtonTheme = void 0;
(function (UitkButtonTheme) {
    UitkButtonTheme["SOLID"] = "solid-btn";
    UitkButtonTheme["TRANSPARENT"] = "transparent-btn";
})(exports.UitkButtonTheme || (exports.UitkButtonTheme = {}));
var UitkButton = /** @class */ (function (_super) {
    tslib.__extends(UitkButton, _super);
    function UitkButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkButton.prototype.render = function () {
        var _a, _b;
        var href = this.props.href;
        var _c = this.props, analytics = _c.analytics, children = _c.children, className = _c.className, domRef = _c.domRef, isFullWidth = _c.isFullWidth, size = _c.size, tag = _c.tag, attributes = tslib.__rest(_c, ["analytics", "children", "className", "domRef", "isFullWidth", "size", "tag"]);
        var Tag = tag || (href ? 'a' : 'button');
        var newChildren = [];
        var buttonProps = tslib.__assign({}, attributes);
        if (Tag === 'button' && !buttonProps.type) {
            buttonProps.type = 'button';
        }
        // Enable :active css state on touch devices.
        // https://css-tricks.com/snippets/css/remove-gray-highlight-when-tapping-links-in-mobile-safari/
        if (!buttonProps.onTouchStart) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            buttonProps.onTouchStart = function () { };
        }
        var childrenCount = React__namespace.Children.toArray(children).length;
        var badge;
        var trailingIcon;
        var leadingIcon;
        var buttonText;
        var a11yText;
        React__namespace.Children.forEach(children, function (child, index) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var existingClassName = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.className;
            a11yText = ((_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b['data-a11ytext']) === 'true';
            if (((_d = (_c = child === null || child === void 0 ? void 0 : child.type) === null || _c === void 0 ? void 0 : _c.displayName) === null || _d === void 0 ? void 0 : _d.includes('UitkNotificationBadge')) ||
                ((_f = (_e = child === null || child === void 0 ? void 0 : child.type) === null || _e === void 0 ? void 0 : _e.displayName) === null || _f === void 0 ? void 0 : _f.includes('UitkBadgeNotification'))) {
                badge = React__namespace.cloneElement(child, { className: 'uitk-button-notification-badge' });
            }
            else if (((_g = child === null || child === void 0 ? void 0 : child.type) === null || _g === void 0 ? void 0 : _g.displayName) === 'UitkIcon') {
                leadingIcon =
                    !leadingIcon && index === 0
                        ? React__namespace.cloneElement(child, { className: getClassNameList(existingClassName, 'uitk-icon-leading') })
                        : leadingIcon;
                trailingIcon =
                    !trailingIcon && index !== 0 && index + 1 === childrenCount
                        ? React__namespace.cloneElement(child, { className: getClassNameList(existingClassName, 'uitk-icon-trailing') })
                        : trailingIcon;
            }
            else if (typeof child === 'string' || (typeof ((_h = child === null || child === void 0 ? void 0 : child.props) === null || _h === void 0 ? void 0 : _h.children) === 'string' && !a11yText)) {
                buttonText = buttonText || child;
            }
            else {
                newChildren.push(child);
            }
        });
        if (!buttonProps.onClickCapture && analytics) {
            buttonProps.onClickCapture = uitkReactUtils.analyticsTracker.bind(this, analytics);
        }
        var hasIcon = leadingIcon || trailingIcon;
        var onlyIcon = (hasIcon && childrenCount === 1) || (hasIcon && a11yText && childrenCount === 2);
        var wrapperClassNames = getClassNameList(UitkButton.baseClassName, (_a = {},
            _a["".concat(UitkButton.baseClassName, "-").concat(size)] = uitkReactUtils.validatePropType(size, exports.UitkButtonSize),
            _a), (_b = {},
            _b["".concat(UitkButton.baseClassName, "-fullWidth")] = isFullWidth,
            _b["".concat(UitkButton.baseClassName, "-has-text")] = buttonText,
            _b["".concat(UitkButton.baseClassName, "-only-icon")] = onlyIcon,
            _b["".concat(UitkButton.baseClassName, "-as-link")] = href,
            _b), className);
        return (React__namespace.createElement(Tag, tslib.__assign({}, buttonProps, { className: wrapperClassNames, ref: domRef }),
            badge && !(trailingIcon || leadingIcon) && badge,
            leadingIcon,
            buttonText,
            newChildren,
            trailingIcon));
    };
    UitkButton.displayName = 'UitkButton';
    UitkButton.defaultProps = {
        isFullWidth: false,
        size: exports.UitkButtonSize.MEDIUM
    };
    UitkButton.baseClassName = 'uitk-button';
    return UitkButton;
}(React__namespace.Component));

exports.UitkButton = UitkButton;
